import Client from '../axios-client';

const resource = '/application';

export default {
  getSettlementById(settlementId) {
    return Client.get(`${resource}/settlement/${settlementId}`);
  },
  makeAutoWithdrawal(settlementId, payload) {
    return Client.put(`${resource}/settlement/${settlementId}/make-auto-withdrawal`, payload);
  },
  makeManualWithdrawal(settlementId, payload) {
    return Client.put(`${resource}/settlement/${settlementId}/make-manual-withdrawal`, payload);
  },
  getSettlementByApplicationId(applicationId) {
    return Client.get(`${resource}/${applicationId}/settlement`);
  }
};
